import React, { useEffect, useState } from 'react';
import { base_url } from '../Api/Api';
import { Loader } from '../Global/Loader';

import Navbar from '../Global/Navbar';
import Header from '../Global/Header';
import Itemcategory from './Itemcategory';

const Homepage = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true
    })

    useEffect(() => {

        if (JSON.parse(localStorage.getItem('logined')) == null) {
            props.history.push(`/Entrance`)
        }


        base_url.get("education")
            .then(response => {
                console.log(response.data, 'education')
                setState({
                    ...state,
                    data: response.data,
                    loader: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    setState({
                        ...state,
                        loader: false
                    })
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    const handleSaveCategory = (id) => {
        console.log(id)
        const data = null;
        state.data.map((info) => {
            if (info.id == id) {
                localStorage.setItem('category', JSON.stringify({ 0: { ...info } }));
                props.history.push("/Education/category/0")
            }
        })
    }

    return (
        <div className="instructpg education">
            <Loader
                active={state.loader} />
            <Header />
            <div className="body-instructpg">

                <div className={`inner-education ${state.loader ? 'active' : ''}`}>
                    {state.data.length == 0 ?
                        <span className="no-content">اطلاعاتی وجود ندارد</span>
                        :
                        state.data.map((info) =>
                            <Itemcategory
                                key={info.id}
                                id={info.id}
                                image={info.image}
                                title={info.name}
                                setCategory={() => handleSaveCategory(info.id)} />
                        )}
                </div>

            </div>
            <Navbar />
        </div>
    );
}

export default Homepage;